var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:_vm.componenteClass(_vm.componente.tipografia)},[_vm._v(_vm._s(_vm.componente.text.label['es_ES']))])])}
var staticRenderFns = []

export { render, staticRenderFns }